import type { IconData } from '@stacksjs/iconify-core'

export const ga1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#ffe700\" d=\"M512 512H0V0h512z\"/><path fill=\"#36a100\" d=\"M512 170.7H0V0h512z\"/><path fill=\"#006dbc\" d=\"M512 512H0V341.3h512z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ga1x1
